import { Formik as FormContainer, Form, useFormik } from 'formik';

import * as FormValidationUtils from './ValidationUtils';
import {
  FormTextMaskedInput,
  TextMaskedInput,
  FormTextInput,
  Input,
  TextArea,
  FormTextArea,
  Selection,
  FormSelection,
  SearchSelectionInput,
  FormSearchSelectionInput,
  RadioInput,
  FormRadioInput,
  CheckboxInput,
  FormCheckboxInput,
} from './FormikInput';

const MuiInput = Input;
MuiInput.Input = Input;
MuiInput.TextArea = TextArea;
MuiInput.Selection = Selection;
MuiInput.TextMaskedInput = TextMaskedInput;
MuiInput.SearchSelectionInput = SearchSelectionInput;

const FormikInput = FormTextInput;
FormikInput.Input = FormTextInput;
FormikInput.TextArea = FormTextArea;
FormikInput.Selection = FormSelection;
FormikInput.RadioInput = FormRadioInput;
FormikInput.MaskedInput = FormTextMaskedInput;
FormikInput.CheckboxInput = FormCheckboxInput;
FormikInput.SearchSelectionInput = FormSearchSelectionInput;

export default {
  FormContainer,
  Form,
  MuiInput,
  FormikInput,
  RadioInput,
  CheckboxInput,
  FormValidationUtils,
  useFormik,
};
